import Header from "../../../layouts/Header"
import { styled, createTheme, ThemeProvider } from "@mui/material/styles"
import { Box } from "@mui/material"

import BackIcon from "../../../components/BackIcon"
import { useNavigate } from "react-router-dom"
import normalFormatDate from "../../utils/date/DDMMYYYFormatDate"
import CustomConditionalActionsTableServer from "../../../components/CustomConditionalActionsTableServerSide"
import EditIcon from "@mui/icons-material/Edit"
import DeleteIcon from "@mui/icons-material/Delete"
import { useMutation } from "@tanstack/react-query"
import fetchwrapper from "../../../services/interceptors/fetchwrapper"
import CustomBackdrop from "../../../components/CustomBackdrop"
import Swal from "sweetalert2"
import EliminarIcon from "../../../assets/iconos/Eliminar.ico"
import DetalleIcon from "../../../assets/iconos/Detalle.ico"
import RemoveRedEyeIcon from "@mui/icons-material/RemoveRedEye"

const StyledRoot = styled(Box)(({ theme }) => ({
  display: "flex",
  flexDirection: "column",
  marginTop: theme.spacing(8),
  flexGrow: 1,
  padding: "0 16px",
  height: "100vh",
}))

const theme = createTheme({
  palette: {
    primary: {
      main: "#196C87",
    },
    secondary: {
      main: "#196C87", // Cambia el color secundario a verde azulado
    },
  },
})

const AdministradorPedidosMostradorBuscar = () => {
  const navigate = useNavigate()
  const { mutateAsync: deleteCita, isPending: isDeletingCita } = useDeleteCita()
  function useDeleteCita() {
    // const queryClient = useQueryClient()
    return useMutation({
      mutationFn: async (pednumped) => {
        const options = {
          method: "DELETE",
          body: JSON.stringify({ pednumped }),
          headers: {
            "Content-Type": "application/json",
            "Access-Control-Allow-Origin": "*",
          },
        }
        const response = await fetchwrapper(`/AdministradorPedidosMostrador/deleteCita`, options)
        return response
      },
    })
  }

  const handleDeleteCita = async (row, useGetObjActionsTableServer) => {
    const pednumped = row.pednumped
    const { refetch } = useGetObjActionsTableServer
    try {
      const result = await Swal.fire({
        title: `¿Estás seguro de eliminar la cita ${pednumped}?`,
        text: "¡No podrás revertir esta acción!",
        icon: "warning",
        showCancelButton: true,
        confirmButtonColor: "#3085d6",
        cancelButtonColor: "#d33",
        confirmButtonText: "Sí, eliminar!",
        cancelButtonText: "Cancelar",
      })

      if (result.isConfirmed) {
        // Si el usuario confirma
        await deleteCita(pednumped)
        await refetch()
        await Swal.fire({
          title: "¡Eliminado!",
          text: `La cita ${pednumped} ha sido eliminada.`,
          icon: "success",
          confirmButtonText: "Aceptar",
        })
        return true
      } else {
        // Si el usuario cancela
        await Swal.fire({
          title: "Cancelado",
          text: `La cita ${pednumped} no ha sido eliminada.`,
          icon: "error",
          confirmButtonText: "Entendido",
        })
        return false
      }
    } catch (error) {
      alert("Error al eliminar la cita")
      console.log("Error completo: " + error)
    }
  }
  return (
    <ThemeProvider theme={theme}>
      <Header />
      <div className="main main-app p-3 p-lg-4">
        <BackIcon />
        <div
          style={{
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            margin: "0 30px 30px 30px",
            fontSize: "25px",
          }}
        ></div>
        <CustomBackdrop isLoading={isDeletingCita} />

        <Box className={StyledRoot}>
          <CustomConditionalActionsTableServer
            endpoint="/AdministradorPedidosMostrador/getAllCitasBuscar"
            errorMsgFilterSearch="Error en cargar datos"
            queryKeyModal="AdministradorPedidosMostradorCitasBuscar"
            perPage={10}
            rowActionsWidthTable={140}
            rowActions={(row) => {
              const record = row.original
              const actions = [
                {
                  label: "Ver",
                  key: "VerAction",
                  icon: <RemoveRedEyeIcon sx={{ color: "#14AFF7" }} />,
                  onClick: (row) => {
                    navigate(`cita`, { state: row.original })
                  },
                },
              ]

              if (record?.hasPermissionToUpdate !== 0) {
                actions.push({
                  label: "Actualizar",
                  key: "ActualizarAction",
                  icon: <img src={DetalleIcon} alt="Eliminar" width={23} />,
                  onClick: (row) => {
                    navigate(`/home/dashboard/RecepcionTemp/actualizar/cita`, { state: row.original })
                  },
                })
              }

              if (record?.hasPermissionToDelete !== 0) {
                actions.push({
                  label: "Eliminar",
                  key: "EliminarAction",
                  icon: <img src={EliminarIcon} alt="Eliminar" width={23} />,
                  onClick: (row, useGetObjActionsTableServer) => {
                    handleDeleteCita(row?.original, useGetObjActionsTableServer)
                  },
                })
              }

              return actions
            }}
            columnsTable={[
              {
                accessorKey: "pednumped",
                header: "ID Cita",
                size: 150,
                Cell: ({ cell }) => <span>{cell.getValue()}</span>,
              },
              {
                accessorKey: "vennombre",
                header: "Vendedor",
                size: 200,
                Cell: ({ cell }) => <span>{cell.getValue()}</span>,
              },
              {
                accessorKey: "nickname",
                header: "Nickname",
                size: 200,
                Cell: ({ cell }) => <span>{cell.getValue()}</span>,
              },
              {
                accessorKey: "comentario",
                header: "Comentario",
                size: 300,
                Cell: ({ cell }) => <span>{cell.getValue()}</span>,
              },
              {
                accessorKey: "pedfecemi",
                header: "Fecha Emisión",
                size: 150,
                Cell: ({ cell }) => {
                  const value = cell.getValue()
                  return <span>{normalFormatDate(value)}</span> // Formatear la fecha
                },
              },
              {
                accessorKey: "pedfecven",
                header: "Fecha Vencimiento",
                size: 150,
                Cell: ({ cell }) => {
                  const value = cell.getValue()
                  return <span>{normalFormatDate(value)}</span> // Formatear la fecha
                },
              },
            ]}
          />
        </Box>
      </div>
    </ThemeProvider>
  )
}

export default AdministradorPedidosMostradorBuscar
